import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/upload_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-4dfd29fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-row-center-center font-blod co-1F2D48 fz-18 pl-20 ptb-20" }
const _hoisted_2 = { class: "fz-15 co-1F2D48 pb-30 plr-20" }
const _hoisted_3 = { class: "flex-column-center-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-34",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "fz-14 co-0066FF mt-10" }
const _hoisted_6 = { class: "flex-row-center-center pr-20" }

import { ref, getCurrentInstance, onUnmounted } from 'vue';
import config from '@/api/config';
import translate from '@/api/translate';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportFile',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const { proxy } = getCurrentInstance() as any;
const emits = __emit;
const ElUploadFile = ref<any>();
const pop = ref(false);
const detail = ref<any>();
const loading = ref(false);
const file = ref("");
const token = ref<any>(localStorage.getItem('token'));
const FileId = ref("");
let timer: any = "";
const percentage = ref(0);
const StartUpLoad = ref(false);

onUnmounted(() => {
	timer && clearInterval(timer);
});

const Submit = () => {
	close();
};
const UpLoadSuccess = (data: any) => {
	if (data.code == 200) {
		FileId.value = data.data;
		StartUpLoad.value = true;
		QuerypProgress();
	} else {
		proxy.$message.error(translate.ShowText('文件上传失败')); // 文件上传失败
	}
};
const DownLoadFile = () => {
	if (!detail.value.downapi) {
		proxy.$message.error("api链接不能为空");
		return false;
	}
	if (loading.value) {
		return false;
	}
	loading.value = true;
	proxy.$api.tokenRequest({
		url: detail.value.downapi,
		isLoading: translate.ShowText('加载中...'), // 加载中...
		success: (res: any) => {
			loading.value = false;
			let a: any = document.createElement('a');
			a.href = res.data;
			a.setAttribute('download', `${detail.value.downname} ${translate.ShowText('模板')}`);
			a.click();
			a = null;
		},
		fail: () => {
			loading.value = false;
		},
	});
};
const QuerypProgress = () => {
	timer && clearTimeout(timer);
	proxy.$api.tokenRequest({
		url: '/queue/progress',
		data: {
			id: FileId.value
		},
		success: (res: any) => {
			if (res.data.status == 1) {
				StartUpLoad.value = true;
				timer = setTimeout(() => {
					clearTimeout(timer);
					QuerypProgress();
				}, 500);
			} else if (res.data.status == 2) {
				StartUpLoad.value = true;
				percentage.value = res.data.progress;
				timer = setTimeout(() => {
					clearTimeout(timer);
					QuerypProgress();
				}, 500);
			} else if (res.data.status == 3) {
				timer && clearTimeout(timer);
				proxy.$message.success(translate.ShowText('文件上传完成')); // 文件上传完成
				StartUpLoad.value = false;
				percentage.value = 0;
				ElUploadFile.value.clearFiles();
				close();
				emits("change");
			} else if (res.data.status == 4) {
				StartUpLoad.value = false;
				percentage.value = 0;
				proxy.$message.error(translate.ShowText('文件上传失败，请重新尝试')); // 文件上传失败，请重新尝试
			}
		},
	});
};
const DialogClose = () => {
	timer && clearInterval(timer);
};
const open = (params: any) => {
	pop.value = true;
	detail.value = params;
};
const close = () => {
	pop.value = false;
};

__expose({
	open,
	close,
});

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: pop.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pop).value = $event)),
      title: "",
      width: "520px",
      "destroy-on-close": "",
      "align-center": true,
      onClose: DialogClose
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(detail.value.name), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            class: "down-btn",
            plain: "",
            type: "primary",
            onClick: DownLoadFile
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate).ShowText('模板下载')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "sure-btn",
            type: "primary",
            onClick: Submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate).ShowText('确认')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_upload, {
            ref_key: "ElUploadFile",
            ref: ElUploadFile,
            drag: "",
            action: `${_unref(config).request_host}${detail.value.upapi}`,
            "on-success": UpLoadSuccess,
            headers: { Authorization: token.value, version: 'v1' }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(StartUpLoad.value ? _unref(translate).ShowText('文件上传中...') :
							_unref(translate).ShowText('点击或将文件拖拽到这里上传')), 1)
              ])
            ]),
            _: 1
          }, 8, ["action", "headers"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})